<template>
  <div class="">
    <div class="query-form">

      <a-row type="flex" style="width: 100%;">
        <!-- <a-col :sm="24" :md="24" :lg="12" :xl="8">
          

        </a-col> -->
        <a-col :sm="24" :md="24" :lg="21" :xl="21">
          <!-- 关键词搜索 -->
        <div class="search-keyword">
          <a-input placeholder="输入关键字搜索" v-model="blurry" style="margin: 0 20px;" @pressEnter="blurrySearch"></a-input>
          <a-button @click="blurrySearch" type="primary">搜索</a-button>
        </div>
        
        <!-- <a-button-group style="float:left;margin: 8px 20px  8px 0;">
          <a-button @click="toggleType(1)" :type="state === 1 ? 'primary' : ''">全部</a-button>
          <a-button @click="toggleType(2)" :type="state === 2 ? 'primary' : ''">已认证</a-button>
          <a-button @click="toggleType(3)" :type="state === 3 ? 'primary' : ''">未认证</a-button>
        </a-button-group> -->
        <a-popover 
          class="advanced-search"
          placement="bottomLeft"
          trigger="click"
          v-model="searchVisible">
          <template slot="content">
            <a-form :form="form" style="width:350px;" class="form-container">
              <a-row>
                <a-col :sm="24" :md="24" :lg="24" :xl="24">
                  <a-form-item v-bind="formItemLayout" label="认证状态" colon > 
                    <a-select v-decorator='["state",{
                      initialValue:state
                    }]' style="min-width:80px;margin-right: 20px;">
                      <a-select-option v-for ="item in stateList" :value="item.key" :key="item.key">{{item.value}}</a-select-option>
                    </a-select> 
                  </a-form-item>
                </a-col>
                <a-col :sm="24" :md="24" :lg="24" :xl="24">
                  <a-form-item v-bind="formItemLayout" label="地区选择" colon >
                    <a-cascader  v-decorator='["province"]' :options="cascaderOptions" @change="regionOnChange" :showSearch="{filter}" placeholder="请选择地区" />
                  </a-form-item>
                </a-col>
                <a-col :sm="24" :md="24" :lg="24" :xl="24" style="text-align:center;">
                  <a-button type="primary" style="margin-right:40px;" @click="resetFields"> 重置 </a-button>
                  <a-button type="primary"  @click="advancedSearchhandleOk"> 查询 </a-button>
                </a-col>
              </a-row>
          </a-form>
          </template>
          <template slot="title">
            <h2 style="font-weight: bold; line-height:32px;">高级搜索</h2>
          </template>
          <a-button type="text" icon="search" style="color:#40a9ff;">高级搜索</a-button>
        </a-popover>
        </a-col>
        <a-col :sm="24" :md="24" :lg="3" :xl="3">
          <router-link
            style="float:right;padding: 13px 0;"
            :to="{
            path: '/user/admin/userManage',
            name:'user-manage' }"
          ><a-icon type="rollback" />返回</router-link>
        </a-col>
        
      </a-row>




    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :dataSource="tableData"
        :pagination="pagination"
        @change="pagChange"
        @expandRowByClick="true"
        :rowKey="record => record.id"
        :loading="loading"
      >
      <!-- 自定义基础信息 -->
      <template slot="name"  slot-scope="record">
        <p>{{record.name}}</p>
        <p>{{record.orgcode}}</p>
      </template>
      <!-- 自定义联系方式 -->
    <template slot="usermsg"  slot-scope="record">
      <p>{{record.contacts}}</p>
      <p>{{record.userPhones}}</p>
    </template>
     <!-- 自定义地区 -->
    <template slot="region" slot-scope="record" >
      <p v-if="record.region">{{record.region.label}}{{record.region.children[0].label}}</p>
      <span v-else>{{record.region}}</span>
    </template>
      <!-- 自定义联系人 -->
      <template slot="userPhones" slot-scope="record" >
        <template v-if="record.phones">
          <p v-for="(item,index) in record.phones" :key="index">{{item}}</p>
        </template>
      </template>
      <!-- 自定义状态 -->
      <template slot="enable"  slot-scope="record">
          {{record.enable?'已认证':'未认证'}}
      </template>
      </a-table>
    </div>
  </div>
  
</template>

<script>
const align = 'center'
const columns = [
  {
    title: "基本信息",
    scopedSlots: { customRender: 'name' },
    align
  },
  {
    title: "邀请码",
    dataIndex: "invitation",
    align
  },
  {
    title: "省市地区",
    // dataIndex: "region",
    scopedSlots: { customRender: 'region' },
    align
  },
  {
    title: "联系方式",
    scopedSlots: { customRender: 'usermsg' },
    align
  },
  {
    title: "注册号码",
    scopedSlots: { customRender: 'userPhones' },
    align
  },
  {
    title: "证书数量(份)",
    dataIndex: "certNum",
    align
  },
   {
    title: "报告数量(份)",
    dataIndex: "reportNum",
    align
  },
    {
    title: "状态",
    scopedSlots: { customRender: 'enable'},
    align
  },
];

let stateList = [
  {key:'1',value:'全部'},
  {key:'2',value:'已认证'},
  {key:'3',value:'未认证'},
]
import {
   getAgencyManage// 基本信息

   } from "@/api/user"
export default {
  data() {
    return {
      stateList,
      state:'1',
      tableData:[],
      loading:false,
      columns,
      pagination: {
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
      params:{
        enable:'',
        page:1,
        size:10,
        blurry:'',
        deptId:'',
        region:'',
      },
      searchVisible:false,
      formItemLayout:{
        labelCol: {
            span: 5
        },
        wrapperCol: {
            span: 17
        },
      },
      form: this.$form.createForm(this),
      cascaderOptions:[],
      deptId:'',
      blurry:'',
      enable: 1,
      advancedSearchParams:{
        state:'',
        region:'',
      },
      selectedRegion:'',
    };
  },
  mounted() {
    this.deptId = this.$route.query.id;
    this.getList()
    this.cascaderOptions = this.$province
  },
  methods: {
    getList(){
      // let params = {
      //   deptId:this.deptId,
      //   page:this.pagination.current -1,
      //   size:this.pagination.pageSize,
      //   // blurry:this.blurry,
      // }
      this.params.page = this.pagination.current -1
      this.params.size = this.pagination.pageSize
      this.params.blurry = this.blurry
      this.params.deptId = this.deptId
      this.loading = true
      // console.log("this.params",this.params)
      getAgencyManage(this.params).then(res => {
        this.tableData = res.content
        this.pagination.total = res.totalElements
        this.loading = false
      })
    },
    pagChange(pagination,filters,sorter){
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getList()
    },

    toggleType(enable){
      this.enable = enable
      if(enable == 2){ // 已认证
        this.params.enable = 1
      }else if(enable==3){ //未认证
        this.params.enable = 0
      }else {  // 其他  或者type为0则为查询全部
        this.params.enable = ''
      }
      // this.pagination.current = 1
      this.getList()
    },
    blurrySearch(){
      this.params.blurry = this.blurry
      this.getList()
    },
    /**
     * 高级搜索
     */
    advancedSearchhandleOk(){
      this.searchVisible= false
      const formObj = this.form.getFieldsValue()
      if(formObj.state){
        this.advancedSearchParams.state = formObj.state
      }
      if(this.selectedRegion){
        this.advancedSearchParams.region = this.selectedRegion
      }else{
        this.advancedSearchParams.region = ''
      }
      // console.log("this.advancedSearchParams",this.advancedSearchParams)
      this.advancedSearch(this.advancedSearchParams)
    },
    advancedSearch(params){
      if(params.state == '2'){ // 已认证
        this.params.enable = 1
      }else if(params.state == '3'){ //未认证
        this.params.enable = 0
      }else {  // 全部
        this.params.enable = ''
      }
      this.params.region = params.region
      this.getList()
    },

    /**
     * 重置搜索
     */
    resetFields(){
      this.selectedRegion = ''
      this.form.resetFields()
      this.advancedSearchhandleOk()
    },
    regionOnChange(value, selectedOptions){
      if(selectedOptions){
        let selectedLabel = []
        selectedOptions.filter(item => {
          selectedLabel.push(item.value)
        })
        this.selectedRegion = selectedLabel.join(',')
      }else{
        this.selectedRegion = ''
      }
    },
    filter(inputValue, path) {
      return path.some(
        option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
      );
    },
  }
};
</script>

<style lang="less" scoped>
.table {
  background-color: #fff;
  .ant-alert-info {
    padding: 3px 15px 3px 37px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;

    /deep/.ant-alert-icon {top: auto !important;}

    .info-slot {
      display: flex;
      align-items: center;

      .ant-btn {padding-right: 0px;}
    }
  }
}
.query-form {
  background-color: #fff;
  overflow: hidden;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  

  .search-keyword {
    max-width: 500px;
    width: 57%;
    min-width: 400px;
    float: left;
    margin: 8px 20px  8px 0;
    display: flex;
    align-items: center;
    .ant-input {margin-right: 10px;}
  }.advanced-search{
    margin: 8px 20px  8px 0;
    .form-container{
      width: 500px;
    }
  }
}
</style>
